import { render, staticRenderFns } from "./SearchByFilters.vue?vue&type=template&id=bf856894&scoped=true&"
import script from "./SearchByFilters.vue?vue&type=script&lang=js&"
export * from "./SearchByFilters.vue?vue&type=script&lang=js&"
import style0 from "./SearchByFilters.vue?vue&type=style&index=0&id=bf856894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf856894",
  null
  
)

export default component.exports